import script from "./forget_password.vue?vue&type=script&setup=true&lang=js"
export * from "./forget_password.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__